import { useEffect } from "react";
import { useHistory } from "react-router-dom";

const TokenSync = () => {
  const history = useHistory();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    const redirectBack = urlParams.get("redirectBack");
    
    if (token) {
      localStorage.setItem("token", token);
    }

    // Optional: Clean up URL
    window.history.replaceState({}, document.title, window.location.pathname);

    // Redirect back after storing token
    setTimeout(() => {
      if (redirectBack) {
        window.location.href = redirectBack;
      } else {
        history.push("/"); // fallback if no redirectBack
      }
    }, 300);
  }, [history]);

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "1.5rem",
        fontWeight: "bold",
      }}
    >
      Loading...
    </div>
  );
};


export default TokenSync;